module.exports = __webpack_public_path__ + "assets/img/5p.14e7aaf1.png";